export { default } from './rich-text';
